import { render } from "./NewTDAParticipants.vue?vue&type=template&id=8b56a020"
import script from "./NewTDAParticipants.vue?vue&type=script&lang=js"
export * from "./NewTDAParticipants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__